






























import ArticlePreview from './ArticlePreview'

export default {
    name: 'Blog'

    props: ['id']

    components:
        ArticlePreview: ArticlePreview

    data: ->
        documentId: @id
        fields: @defaultFields()

    methods:
        defaultFields: ->
            counter: 0
            end: false
            tags: []
            posts: []
    
        setContent: (document) ->
            undefined

        getMoreProjects: () ->
            @$prismic.client.query(
                    [@$prismic.Predicates.at 'document.type', 'article'],
                    orderings: '[my.article.date desc]'
                    pageSize: 3
                    page: @fields.counter = @fields.counter + 1
                ).then (response) =>
                    if response
                        if response.results.length
                            @fields.posts = @fields.posts.concat response.results
                        else
                            @fields.end = true
                    window.prismic.setupEditButton()

     created: ->
        @setContent @$attrs.document
        @getMoreProjects()
}
